export const lightThemeNames = [
  'amexTheme',
  'bmwTheme',
  'cmcTheme',
  'defaultTheme',
  'enpalTheme',
  'elavonTheme',
  'ikanoTheme',
  'ikanoFleksTheme',
  'miniTheme',
  'signicatTheme',
  'santanderTheme',
  'onventisTheme',
  'raisinTheme',
  'nordconceptTheme',
] as const

export const darkThemeNames = [
  // 'defaultDarkTheme',
] as const

export const allThemeNames = [...lightThemeNames, ...darkThemeNames] as const

export const themeNameSchemeMap = {
  light: lightThemeNames,
  dark: darkThemeNames,
} as const

export type ThemeNames = (typeof allThemeNames)[number]
export type ThemeScheme = keyof typeof themeNameSchemeMap
